const industryType = window.localStorage["industryType"];

export function getAll() {
  let items = [
    {
      value: 0,
      name: "tradeStatusType",
      text: "狀態",
      mode: "single",
    },
    {
      value: 1,
      name: "reportSourceType",
      text: "來源",
      mode: "single",
    },
    {
      value: 2,
      name: "cost",
      text: "成本",
      mode: "single",
    },
    {
      value: 3,
      name: "eatType",
      text: "用餐",
      mode: "multiple",
    },
    {
      value: 4,
      name: "Store",
      text: "門市",
      mode: "modal",
    },
    {
      value: 5,
      name: "Terminal",
      text: "收銀台",
      mode: "modal",
    },
    {
      value: 6,
      name: "Employee",
      text: "員工",
      mode: "modal",
    },
  ];
  if (industryType == 2) {
    items.splice(3, 1);
  }
  return items;
}
